import { useLocation } from 'react-router-dom';

import { AppRoutes } from 'constants/routes-paths.constants';
import { DocumentTypeForm } from 'page-components/document-types/DocumentTypeForm';
import { PageLayout } from 'page-components/page-layout/PageLayout';

export const DocumentType = () => {
  const { pathname } = useLocation();

  const editTitle = pathname === AppRoutes.documentTypeCreate ? 'create_document_type' : 'edit_document_type';
  const titleText = pathname.includes('view') ? 'view_document_type' : editTitle;

  return (
    <PageLayout title={titleText} wrapperClassName='flex flex-col gap-4'>
      <DocumentTypeForm />
    </PageLayout>
  );
};
